import React, { Component } from "react";
import Slider from "react-slick";
import TeamCard from "../TeamCard/TeamCard";
import client from "../../../utils/prismicHelpers";
import * as queries from "../../../utils/prismicQueries";
import leftBtn from "./../../../assets/images/arrow-left.png";
import leftBtnBlr from "./../../../assets/images/arrow-left-blur.png";
import rightBtn from "./../../../assets/images/arrow_right.png";
import rightBtnBlr from "./../../../assets/images/arrow-right-blur.png";
export default class TeamSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliders: null,
      newSlider: null,
      sliderBtn: false,
      activeSlide2: 0,
      activeSlide: 0,
      hasLoaded: false,
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  listenScrollEvent(event) {}

  componentDidMount() {
    client
      .query({ query: queries.teamSlider })
      .then((response) => {
        const sliderInfo = response.data.allTeams.edges[0].node.mamber_info;

        this.setState({ sliders: sliderInfo, hasLoaded: true });
        this.setState({ newSlider: sliderInfo });
        setTimeout(() => {
          this.slider.slickGoTo(0);
        }, 1000);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  next() {
    this.slider.slickNext();
    this.setState({ sliderBtn: true });
  }

  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      className: "center",
      dots: true,
      infinite: false,
      centerPadding: "60px",
      slidesToShow: 3,
      speed: 500,
      rows: 2,
      slidesToScroll: 3,
      slidesPerRow: 1,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
      afterChange: (current) =>
        this.setState({ activeSlide2: current * 2 + 6 }),
      responsive: [
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            rows: 3,
            afterChange: (current) =>
              this.setState({ activeSlide2: current * 2 + 6 }),
          },
        },
        {
          breakpoint: 300,
          settings: {
            dots: true,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
          },
        },
      ],
    };

    return this.state.hasLoaded ? (
      <div className="team-slider">
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {this.state.sliders?.map((teamInfo) => (
            <TeamCard
              key={Date.now() + Math.random()}
              teamInfo={teamInfo}
            ></TeamCard>
          ))}
        </Slider>
        <div className="d-flex justify-content-between pt-3 ">
          <img
            src={this.state.activeSlide === 0 ? leftBtn : leftBtnBlr}
            alt=""
            className="img-fluid d-inline pinter-cursor"
            onClick={this.previous}
          />

          <img
            src={
              this.state.activeSlide2 === this.state?.sliders?.length
                ? rightBtnBlr
                : this.state.activeSlide2 === this.state?.sliders?.length + 1
                ? rightBtnBlr
                : rightBtn
            }
            alt=""
            className="img-fluid d-inlinek pinter-cursor"
            onClick={this.next}
          />
        </div>
      </div>
    ) : null;
  }
}
